import styles from './RowsAlternating.module.css';
import Arrow from '../assets/arrowTopRight.jsx';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import CMSLink from './common/CMSLink.jsx';
import { useParams } from "react-router-dom";

export default function RowsAlternating({ title, items }) {

    const { lang } = useParams();

    return (
        <div className={`${styles.rows_alternating} ${lang === "ko" && styles.lang_ko}`}>

            {items.map((item, i) => {

                const aspectRatio = (item.fields.media.fields.file.details.image.height / item.fields.media.fields.file.details.image.width) * 100;
                const mediaStyle = { paddingTop: `${aspectRatio}%` };

                return (

                    <div className={`${styles.row} ${i % 2 == 0 ? styles.odd : styles.even}`} key={i}>

                        {i == 0 && title &&
                            <div className={`${styles.section_title} preserve-line-breaks`}>
                                {title}
                            </div>
                        }

                        <div className={`cell ${styles.cell}`}>

                            <div className={styles.media} style={mediaStyle}>
                                <CMSLink path={item.fields.ctaLink}>
                                    <img
                                        src={`https:${item.fields.media.fields.file.url}`}
                                        alt={item.fields.title}
                                        width={item.fields.media.fields.file.details.image.width}
                                        height={item.fields.media.fields.file.details.image.height}
                                    />

                                    {item.fields.ctaText &&
                                        <div className={`ctaBox ${styles.cta}`} style={{ '--hoverColor': "#FF3633" }}>
                                            <div className="contents">
                                                {item.fields.ctaText}
                                                <Arrow />
                                            </div>

                                        </div>
                                    }
                                </CMSLink>

                            </div>

                            <div className={styles.info}>
                                <h2 className={styles.title}>{item.fields.title}</h2>
                                <div className={styles.summary}>
                                    {documentToReactComponents(item.fields.summary)}
                                </div>
                            </div>


                        </div>

                    </div>

                );

            })}

        </div>
    )
}